'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactMixin = require('react-mixin');

var _reactMixin2 = _interopRequireDefault(_reactMixin);

var _lodashHead = require('lodash.head');

var _lodashHead2 = _interopRequireDefault(_lodashHead);

var Mixin = require('../mixin');
var Glyph = require('./Glyph');
var Pill = require('./Pill');

var Select = (function (_React$Component) {
	_inherits(Select, _React$Component);

	function Select(props) {
		_classCallCheck(this, Select);

		_get(Object.getPrototypeOf(Select.prototype), 'constructor', this).call(this, props);
		this.displayName = 'Select';
		this.focusedRef = null;
		this.menuRef = null;
		this.flattenedOptions = this.getFlattenedOptions(this.props);
		var state = this.getSelectedOption(this.props) || {};
		state.isOpen = false;

		this.state = state;
	}

	_createClass(Select, [{
		key: 'componentWillReceiveProps',
		value: function componentWillReceiveProps(nextProps) {
			this.flattenedOptions = this.getFlattenedOptions(nextProps);
			this.setState(this.getSelectedOption(nextProps));
		}
	}, {
		key: 'componentDidUpdate',
		value: function componentDidUpdate(prevProps, prevState) {
			// Scroll menu while navigating through options in case of accessibility (using keyboard).
			if (this.state.isOpen && this.focusedRef && this.menuRef) {
				var focusedRect = this.focusedRef.getBoundingClientRect(),
				    menuRect = this.menuRef.getBoundingClientRect(),
				    focusedDOM = _reactDom2['default'].findDOMNode(this.focusedRef),
				    menuDOM = _reactDom2['default'].findDOMNode(this.menuRef);

				if (focusedRect.bottom > menuRect.bottom) {
					menuDOM.scrollTop = focusedDOM.offsetTop + focusedDOM.clientHeight - menuDOM.clientHeight;
				} else if (focusedRect.top < menuRect.top) {
					menuDOM.scrollTop = focusedDOM.offsetTop;
				}
			}
		}
	}, {
		key: 'getNotification',
		value: function getNotification(hasError, leftPadding, rightPadding) {
			var _this = this;

			var notification = [];
			var list = function list(item, index) {
				return _react2['default'].createElement(
					'li',
					{ key: index },
					item
				);
			};

			var help = function help() {
				return _react2['default'].createElement(
					'div',
					{ className: (0, _classnames2['default'])('Select-info') },
					_react2['default'].createElement(
						'ul',
						null,
						_this.props.help.map(list)
					)
				);
			};

			if (this.props.help && this.props.help.length > 0) {
				notification.push(help());
			}

			return notification;
		}
	}, {
		key: 'getFlattenedOptions',
		value: function getFlattenedOptions(props) {
			// Flatten a possibly nested array of options to a 1D array for indexing
			var flattenedOptions = props.options || [];

			function flatten(acc, cur) {
				if (Array.isArray(cur.children)) {
					return cur.children.reduce(flatten, acc);
				}
				return acc.concat(cur);
			}

			return flattenedOptions.reduce(flatten, []);
		}
	}, {
		key: 'getFocusedOption',
		value: function getFocusedOption() {
			// Retrieve the option associated with focusedOptionIndex
			var focusedIndex = this.state.focusedOptionIndex,
			    flattenedOptions = this.flattenedOptions || [];

			// Only index into the options array if it's a valid index
			if (focusedIndex >= 0 && focusedIndex < flattenedOptions.length) {
				return flattenedOptions[focusedIndex];
			}

			// for any other case (eg. the focusedIndex is -1), return the placeholder option
			return { label: this.props.placeholder, value: '' };
		}
	}, {
		key: 'renderOptions',
		value: function renderOptions(options, focusedOption, initialIdIndex) {
			var _this2 = this;

			if (options && options.length > 0) {
				var _ret = (function () {
					/* 
      * If `initialIdIndex` is passed in, we want to use that as the new initial value
      * for this iteration of rendering so that the incremental `listIdIndex` that gets used
      * will not be lost in a second call to `renderOptions`.
      */
					var currentIdIndex = initialIdIndex > -1 ? initialIdIndex : -1;
					return {
						v: options.map(function (option, i) {
							var listIdIndex = currentIdIndex;
							// if `option.children` exists, then increment the idIndex by the length of the children
							// for the next option and pass this currentIdIndex down to the children
							if (option.children) {
								currentIdIndex += option.children.length;
							} else {
								// otherwise, just increment the idIndex and use that for the list id
								currentIdIndex++;
								listIdIndex = currentIdIndex;
							}
							var focused = focusedOption && focusedOption.value === option.value && !option.children;
							return _react2['default'].createElement(
								'div',
								{ key: option.value + '-' + listIdIndex },
								_react2['default'].createElement(
									'li',
									{
										id: option.children ? null : option.value + '-' + listIdIndex,
										'aria-selected': focused,
										className: option.children ? (0, _classnames2['default'])('Select-menu-options-parent') : (0, _classnames2['default'])('Select-menu-options', {
											'Select-menu-options-focused': focused
										}),
										role: option.children ? null : 'option',
										ref: function (ref) {
											if (focused) {
												_this2.focusedRef = ref;
											}
										},
										onClick: option.children ? null : _this2.onChange.bind(_this2, option)
									},
									option.label
								),
								option.children ? _this2.renderOptions(option.children, focusedOption, listIdIndex) : null
							);
						})
					};
				})();

				if (typeof _ret === 'object') return _ret.v;
			}
		}
	}, {
		key: 'reducer',
		value: function reducer(accumulator, current) {
			if (Array.isArray(current.children)) {
				var currentCopy = this.cloneObject(current);
				currentCopy.children = currentCopy.children.reduce(this.reducer.bind(this), []);
				accumulator.push(currentCopy);
			} else if (!Array.isArray(this.props.value) && this.props.value !== current.value || Array.isArray(this.props.value) && this.props.value.indexOf(current.value) === -1) {
				accumulator.push(current);
			}
			return accumulator;
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var options = [].concat(this.props.options);
			var selectDropdownStyles = {};

			if (this.props.placeholder) {
				options.unshift({
					label: this.props.placeholder,
					value: ''
				});
			}

			var hasError = this.props.errors.length,
			    isBlur = this.state.selectedOption.length === 0;

			if (this.props.type === 'multiple') {
				options = options.reduce(this.reducer.bind(this), []);
			}

			var _props = this.props;
			var leftPadding = _props.leftPadding;
			var rightPadding = _props.rightPadding;

			var componentLabelId = undefined,
			    selectTextId = undefined,
			    menuId = undefined,
			    selectActiveDescendantId = undefined;
			// if `id` is passed as a prop, initialize the ids needed for ARIA attributes
			if (this.props.id) {
				componentLabelId = this.props.id + '-label';
				selectTextId = this.props.id + '-label-text';
				menuId = this.props.id + '-menu';
			}

			var focusedIndex = this.state.focusedOptionIndex;
			if (this.state.isOpen && focusedIndex >= 0) {
				// if placeholder is present, then all of the ids will be offset by 1
				var indexOffset = this.props.placeholder ? 1 : 0;
				selectActiveDescendantId = this.flattenedOptions[focusedIndex].value + '-' + (focusedIndex + indexOffset);
			}

			var errorIcon = hasError && this.props.showErrorIcon ? _react2['default'].createElement(Glyph, {
				size: 'small',
				type: 'error',
				icon: 'icon-critical-small',
				className: (0, _classnames2['default'])('Select-error-icon'),
				style: {
					paddingLeft: leftPadding ? leftPadding : null,
					paddingRight: rightPadding ? rightPadding : null
				}
			}) : null;

			var arrowIcon = (!hasError || !this.props.showErrorIcon) && !this.props.readOnly ? _react2['default'].createElement(Glyph, {
				size: 'small',
				icon: this.state.isOpen ? 'icon-arrow-up-small' : 'icon-arrow-down-small',
				onClick: this.onClick.bind(this),
				className: (0, _classnames2['default'])('Select-arrow-icon'),
				style: {
					paddingLeft: leftPadding ? leftPadding : null,
					paddingRight: rightPadding ? rightPadding : null
				}
			}) : null;

			var componentLabel = this.props.label ? _react2['default'].createElement(
				'label',
				{
					id: componentLabelId,
					className: (0, _classnames2['default'])('ComponentLabel', {
						'ComponentLabel-blur': isBlur,
						'ComponentLabel-error': hasError,
						'ComponentLabel-readOnly': this.props.readOnly
					}),
					style: {
						paddingLeft: leftPadding ? isBlur ? leftPadding : 'calc(' + leftPadding + ' * 1.45)' : null,
						paddingRight: rightPadding ? isBlur ? rightPadding : 'calc(' + rightPadding + ' * 1.45)' : null
					},
					htmlFor: this.props.id || this.props.htmlFor
				},
				this.props.label
			) : null;
			var selectProps = {
				id: this.props.id,
				className: (0, _classnames2['default'])('Select', {
					error: hasError
				}, this.props.className),
				onBlur: this.onBlur.bind(this),
				onFocus: this.onFocus.bind(this),
				onKeyDown: this.onKeyDown.bind(this),
				onKeyPress: this.onKeyPress.bind(this),
				role: 'listbox',
				'aria-expanded': this.state.isOpen,
				'aria-activedescendant': selectActiveDescendantId,
				'aria-controls': this.state.isOpen ? menuId : null,
				'aria-owns': this.state.isOpen ? menuId : null,
				'aria-labelledby': componentLabelId + ' ' + selectTextId
			};

			// Set tabIndex only for active select dropdown.
			if (!(this.props.readOnly || this.props.disabled)) {
				selectProps['tabIndex'] = '0'; // Set tabIndex to make onBlur work.
			}

			if (isBlur && !this.props.readOnly && this.context.type !== 'basic' && this.context.type !== 'horizontal') {
				selectDropdownStyles = {
					visibility: 'hidden'
				};
			}

			var focusedOption = this.getFocusedOption();

			return _react2['default'].createElement(
				'div',
				selectProps,
				componentLabel,
				_react2['default'].createElement(
					'div',
					{
						className: (0, _classnames2['default'])('Select-label', {
							'Select-label-focused': this.state.isOpen,
							'Select-label-disabled': this.props.disabled,
							'Select-label-readOnly': this.props.readOnly
						}, 'Select-label-' + this.props.type, this.props.size ? 'Select-label-' + this.props.size : null),
						onClick: this.onClick.bind(this),
						style: {
							paddingLeft: leftPadding ? leftPadding : null,
							paddingRight: rightPadding ? hasError && this.props.showErrorIcon ? 'calc(' + rightPadding + ' + 3em)' : rightPadding : null
						}
					},
					_react2['default'].createElement(
						'span',
						{ id: selectTextId, className: 'Select-label-text', style: selectDropdownStyles },
						this.getValues(this.state.selectedOption)
					),
					arrowIcon,
					errorIcon
				),
				this.getNotification(hasError, leftPadding, rightPadding),
				_react2['default'].createElement(
					'ul',
					{
						id: menuId,
						'aria-labelledby': componentLabelId,
						'aria-expanded': this.state.isOpen,
						className: (0, _classnames2['default'])('Select-menu', {
							'Select-menu-show': this.state.isOpen,
							'Select-menu-hide': !this.state.isOpen
						}),
						ref: function (ref) {
							_this3.menuRef = ref;
						}
					},
					this.renderOptions(options, focusedOption)
				)
			);
		}
	}, {
		key: 'getSelectedOption',
		value: function getSelectedOption(props) {
			// Set default 'selected' option as selected option.
			var flattenedOptions = this.flattenedOptions || [],
			    selectedOption = [];

			var selectedIndex = -1; // Considering placeholder as the -1 index

			for (var i = 0; i < flattenedOptions.length; i++) {
				// if (flattenedOptions[i].value === props.value) {
				// 	selectedOption = {
				// 		label: flattenedOptions[i].label,
				// 		value: flattenedOptions[i].value,
				// 	};
				// 	selectedIndex = i;
				// 	break;
				// }
				if (props.type === "multiple" && Array.isArray(props.value) && props.value.indexOf(flattenedOptions[i].value) != -1 || flattenedOptions[i].value === props.value) {
					selectedOption.push({
						label: flattenedOptions[i].label,
						value: flattenedOptions[i].value
					});
					selectedIndex = i;
				}
			}
			return {
				selectedOption: selectedOption,
				focusedOptionIndex: selectedIndex
			};
		}
	}, {
		key: 'onKeyPress',
		value: function onKeyPress(event) {
			if (this.props.disabled || this.props.readOnly) {
				return false;
			}

			var key = event.key,
			    options = this.props.options,
			    option = '',
			    state = {};

			switch (key) {
				case 'Enter':
					{
						// Do nothing. 'Enter' handled in onKeyDown
						break;
					}
				default:
					{
						this.key = this.key || '';
						this.key += key;
						if (options) {
							var flattenedOptions = this.flattenedOptions || [];
							for (var i = 0; i < flattenedOptions.length; i++) {
								option = flattenedOptions[i];
								if (option.label.toUpperCase().indexOf(this.key.toUpperCase()) === 0) {
									state.focusedOptionIndex = i;
									if (!this.state.isOpen) {
										state.isOpen = true;
									}
									this.setState(state);
									return;
								}
							}

							//Reset key when no match found
							this.key = '';
						}
					}
			}
		}
	}, {
		key: 'onKeyDown',
		value: function onKeyDown(event) {
			if (this.props.disabled || this.props.readOnly) {
				return false;
			}
			var keyCode = event.keyCode;

			switch (keyCode) {
				case 40:
					{
						//Down arrow
						event.preventDefault(); // do not scroll the window

						//Navigate down through the options.
						this.optionsNavigateDown();
						break;
					}
				case 38:
					{
						//Up arrow
						event.preventDefault(); // do not scroll the window

						//Navigate up through the options.
						this.optionsNavigateUp();
						break;
					}
				case 27:
					{
						// ESC

						// Close Menu options.
						if (this.state.isOpen) {
							this.hideOptions();
						}
						break;
					}
				case 13:
					{
						//Enter

						var selectedOption = this.getFocusedOption();
						this.onChange.bind(this)(selectedOption);
						break;
					}

				default:
			}
		}
	}, {
		key: 'optionsNavigateDown',
		value: function optionsNavigateDown() {
			if (!this.state.isOpen) {
				this.setState({
					isOpen: true
				});
			} else {
				var flattenedOptions = this.flattenedOptions || [];
				if (this.state.focusedOptionIndex < flattenedOptions.length - 1) {
					this.setState({
						focusedOptionIndex: this.state.focusedOptionIndex + 1
					});
				}
			}
		}
	}, {
		key: 'optionsNavigateUp',
		value: function optionsNavigateUp() {
			if (this.state.isOpen && this.state.focusedOptionIndex >= 0) {
				this.setState({
					focusedOptionIndex: this.state.focusedOptionIndex - 1
				});
			}
		}
	}, {
		key: 'onClick',
		value: function onClick(event) {
			if (!event.currentTarget.isEqualNode(event.target)) {
				return false;
			}

			this.setState({
				isOpen: !this.state.isOpen
			});
		}
	}, {
		key: 'onBlur',
		value: function onBlur(event) {
			var relatedTarget = event.relatedTarget || document.activeElement; // IE11

			if (!relatedTarget || !event.currentTarget.contains(relatedTarget)) {
				this.hideOptions();
				this.props.onBlur && this.props.onBlur(this.props.value, event);

				return true;
			}

			return false;
		}
	}, {
		key: 'onFocus',
		value: function onFocus(event) {
			if (this.props.onFocus) {
				this.props.onFocus(event);
			}
		}
	}, {
		key: 'hideOptions',
		value: function hideOptions() {
			//Reset Key
			this.key = '';

			var state = this.getSelectedOption(this.props) || {};
			state.isOpen = false;

			this.setState(state);
		}
	}, {
		key: 'removeSelectedOption',
		value: function removeSelectedOption(removeOption, event) {

			var removeSelectedoption = this.state.selectedOption.filter(function (option) {
				return option.label !== removeOption.label;
			});

			this.setState({
				selectedOption: removeSelectedoption
			});

			var removeSelectedValue = removeSelectedoption.map(function (option) {
				return option.value;
			});
			if (this.props.onChange) this.props.onChange(removeSelectedValue, event);
		}
	}, {
		key: 'onChange',
		value: function onChange(selectedOption, event) {
			// event.stopPropagation();

			// var isChanged = this.state.selectedOption.label !== selectedOption.label;
			var multipleSelectedoption;
			if (this.props.type === "multiple") {
				multipleSelectedoption = this.cloneObject(this.state.selectedOption);
				selectedOption.value && multipleSelectedoption.push(selectedOption);
				this.setState({
					isOpen: true,
					selectedOption: multipleSelectedoption
				});
			} else {
				this.setState({
					isOpen: false,
					selectedOption: selectedOption
				});
			}

			//Reset Key
			this.key = '';

			//Call User defined onChange method.
			if (this.props.type === "multiple") {
				var multipleSelectedValue = multipleSelectedoption && multipleSelectedoption.map(function (option) {
					return option.value;
				});
				if (this.props.onChange) this.props.onChange(multipleSelectedValue, event);
			} else {
				if (this.props.onChange) this.props.onChange(selectedOption.value, event);
			}
		}
	}, {
		key: 'getValues',
		value: function getValues(selected) {
			var _this4 = this;

			// OnClear will remove the item values and selectedOptions.
			if (this.props.type === "multiple") {
				return selected.map(function (option, index) {
					return _react2['default'].createElement(Pill, { label: option.label, onClear: _this4.removeSelectedOption.bind(_this4, option) });
				});
			} else {
				return (0, _lodashHead2['default'])(selected) && (0, _lodashHead2['default'])(selected).label || this.props.placeholder;
			}
		}
	}]);

	return Select;
})(_react2['default'].Component);

Select.propTypes = {
	options: _propTypes2['default'].arrayOf(_propTypes2['default'].object).isRequired,
	onChange: _propTypes2['default'].func.isRequired,
	placeholder: _propTypes2['default'].string,
	id: _propTypes2['default'].string,
	disabled: _propTypes2['default'].bool,
	readOnly: _propTypes2['default'].bool,
	value: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].string, _propTypes2['default'].number]))]),
	errors: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	size: _propTypes2['default'].oneOf(['lg', 'sm', 'xs']),
	leftPadding: _propTypes2['default'].string,
	rightPadding: _propTypes2['default'].string,
	showErrorIcon: _propTypes2['default'].bool,
	type: _propTypes2['default'].oneOf(["default", "multiple"])
};

Select.defaultProps = {
	errors: [],
	showErrorIcon: true,
	type: "default"
};

Select.contextTypes = {
	type: _propTypes2['default'].string
};

(0, _reactMixin2['default'])(Select.prototype, Mixin);

module.exports = Select;


//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/kepler/lib/components/Select.js
// module id = 267
// module chunks = 0